import { useEffect, useState } from "react";
import { MapPin, ShieldCheck } from "lucide-react";

/**
 * Promo banner displayed above the navbar on Loiret SEO pages.
 * Alternates between 2 messages every 5 seconds.
 */
const MESSAGES = [
  { icon: MapPin, text: "À 15 min d'Orléans sur la RN20 (axe Orléans–Paris)" },
  { icon: ShieldCheck, text: "Propriétaire-bailleur direct — Sans agence, sans commission" },
];

export const TopPromoBanner = () => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx(i => (i + 1) % MESSAGES.length), 5000);
    return () => clearInterval(t);
  }, []);
  const M = MESSAGES[idx];
  const Icon = M.icon;
  return (
    <div
      className="bg-slate-900 text-white py-2 px-4 text-center text-xs sm:text-sm font-semibold tracking-wide flex items-center justify-center gap-2"
      data-testid="top-promo-banner"
    >
      <Icon className="w-4 h-4 text-[#FFC107] shrink-0" />
      <span>{M.text}</span>
    </div>
  );
};

export default TopPromoBanner;
